import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import withStyles from '../../core/withStyles';
import styles from './Menu.styles';
import MenuBack from './MenuBack';
import MenuDrawer from './MenuDrawer';
import MenuDrawerCTA from './MenuDrawerCTA';
import MenuDrawerItem from './MenuDrawerItem';
import MenuHeader from './MenuHeader';
import MenuItem from './MenuItem';
import MenuLogo from './MenuLogo';
import MenuTitle from './MenuTitle';
export const Menu = ({ fixed = false, classes, children, }) => {
    return (_jsx("div", Object.assign({ className: cn(classes.root, fixed && classes.fixed) }, { children: children })));
};
export default Object.assign(withStyles(styles)(Menu), {
    Header: MenuHeader,
    Logo: MenuLogo,
    Item: MenuItem,
    Back: MenuBack,
    Drawer: MenuDrawer,
    DrawerItem: MenuDrawerItem,
    DrawerCTA: MenuDrawerCTA,
    Title: MenuTitle,
});
//# sourceMappingURL=Menu.js.map